// extracted by mini-css-extract-plugin
export default {"tableHeadCell":"TableHeadCell_tableHeadCell__QzRan","sorted":"TableHeadCell_sorted__5YW9e","arrow":"TableHeadCell_arrow__aSWOE","sortedArrow":"TableHeadCell_sortedArrow__txyYF"};